import React, { Component } from 'react';
import { SkyLightStateless } from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';

import { UI_HEIGHT } from '../Common/constants';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import ConfirmActionModal from '../Common/confirmActionModal';
import { DateFormatter } from '../Common/dateFormat';
import CashFormatter from '../Common/cashFormatter';
import SpinnerButton from '../Common/SpinnerButton';
import PrintIframe from '../Common/PrintIframe';
import genericRadioFilter from '../Common/genericRadioFilter';
import dateFilterRadios from '../Common/dateFilterRadios';
import checkPermission from '../Common/permissions';
import { dateFormat, toFromDates } from '../Common/cleanDates';

import { ROOT_URL, companyCodeTitle } from '../../actions/root_url';

class PurchaseReturnList extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
      super();
      this.state = {
        tableHeight: window.innerHeight - UI_HEIGHT.editSalesInvPage,

        createOpen: false,

        rows: [],
        selectedRows: null,
        filters: {},
        sortColumn: null,
        sortDirection: null,

        returnPDFFrameLoaded: true,

        checkAuthorizeOpen: false,
        action: null,

        days: '7',
        fromDate: undefined,
        toDate: undefined,
        filteredByItem: false,
        status: 'all',
        returnPdfFrameLoadedNs: true,
      };

        this.handleResize = this.handleResize.bind(this);
        this.openCreate = this.openCreate.bind(this);
        this.closeCreate = this.closeCreate.bind(this);
        this.checkAuthorize = this.checkAuthorize.bind(this);
        this.openCheckAuthorize = this.openCheckAuthorize.bind(this);
        this.closeCheckAuthorize = this.closeCheckAuthorize.bind(this);
    }

    componentDidMount() {
        document.title = companyCodeTitle;
        window.addEventListener('resize', this.handleResize);
        this.props.fetchPurchaseReturns(this.state.fromDate, this.state.toDate, this.state.days, this.state.status);
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    handleResize(e) {
        this.setState({tableHeight: window.innerHeight - UI_HEIGHT.editSalesInvPage});
    }

    // Once products are ready, reset state..

    componentWillReceiveProps(nextProps) {
      if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
        this.closeCheckAuthorize();
        if (this.state.action === 'void') {
          this.voidPurchaseReturn();
        }
      }
        if (nextProps.purchaseReturns && nextProps.purchaseReturns != this.props.purchaseReturns) {
            let purchaseReturns = nextProps.purchaseReturns;
            purchaseReturns.map(purchaseReturn => {
              purchaseReturn['Name'] = purchaseReturn.Vendor_id.Name;
            })
            this.setState({
                rows: purchaseReturns
            });
        }

        if (nextProps.purchaseReturnPdf && nextProps.purchaseReturnPdf !== this.props.purchaseReturnPdf) {
          this.setState({ returnPDFFrameLoaded: false });
        }

        if (nextProps.purchaseReturnPdfNs && nextProps.purchaseReturnPdfNs !== this.props.purchaseReturnPdfNs) {
          this.setState({ returnPdfFrameLoadedNs: false });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
      if (nextState.returnPDFFrameLoaded !== this.state.returnPDFFrameLoaded && this.state.returnPDFFrameLoaded == false) {
        return false;
      }
      if (nextState.returnPdfFrameLoadedNs !== this.state.returnPdfFrameLoadedNs && this.state.returnPdfFrameLoadedNs == false) {
        return false;
      }

      return true;
    }

    openCreate() { this.setState({ createOpen: true }); }
    closeCreate() { this.setState({ createOpen: false }); }

    checkAuthorize(password) {
      this.props.checkPassword(password);
    }

    openCheckAuthorize(action) {
      this.props.clearCheckPassword();
      this.setState({ checkAuthorizeOpen: true, action });
    }

    closeCheckAuthorize() {
      this.setState({ checkAuthorizeOpen: false });
    }

    voidPurchaseReturn() {
      const purchaseReturnID = (this.state.selectedRows) && this.state.selectedRows[0].PurchaseReturn_id;
      this.props.voidPurchaseReturn(purchaseReturnID).then(() => {
        this.props.fetchPurchaseReturns(this.state.fromDate, this.state.toDate, this.state.days, this.state.status);
      });
    }

    // Set product being selected to be currentProduct and navigate user to the edit page

    setCurrentPurchaseReturn(e) {
        e.preventDefault();
        const currentPurchaseReturn = this.state.selectedRows[0];
        this.props.resetCurrentPurchaseReturn();
        this.props.selectPurchaseReturn(currentPurchaseReturn);
        this.context.router.push('/purchaseReturn/'+currentPurchaseReturn.PurchaseReturn_id);
    }

    createPurchaseReturn(e) {
        e.preventDefault();
        this.props.resetCurrentPurchaseReturn();
        this.context.router.push('/purchaseReturn/new');
    }

    createPurchaseCredit(e) {
        e.preventDefault();
        this.props.resetCurrentPurchaseReturn();
        this.context.router.push('/purchaseReturn/newCredit');
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentPurchaseReturn();
        this.context.router.push('/purchaseReturn/new')
    }

    handlePrintFrameOnLoad = () => {
      this.setState({ returnPDFFrameLoaded: true });
    }

    handlePrintFrameNsOnLoad = () => {
      this.setState({ returnPdfFrameLoadedNs: true });
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><br /><br /><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            let tableHeight = (window.innerHeight < 900) ? 560 : 560;

            const getRows = () => {
                return Data.Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState(state);
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                this.setState({ filters: newFilters });
            }

            // Handle the row select function

            const onRowSelect = rows => {
                this.setState({ selectedRows: rows });
            }

            const VendorNameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNumFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'PRNum',
                    name: <Translate value="return_no" />,
                    resizable: true,
                    sortable: true,
                    width: 105,
                    filterable: true,
                },
                {
                    key: 'Name',
                    name: <Translate value="vendor_name" />,
                    resizable: true,
                    sortable: true,
                    width: 200,
                    filterable: true,
                },
                {
                    key: 'ReturnReason',
                    name: <Translate value="return_reason" />,
                    resizable: true,
                    sortable: true,
                    width: 150,
                    filterable: true,
                },
                {
                    key: 'ReturnStatus',
                    name: <Translate value="return_status" />,
                    resizable: true,
                    sortable: true,
                    width: 150,
                    filterable: true,
                },
                {
                    key: 'FinalPrice',
                    name: <Translate value="final_dollarsign" />,
                    resizable: true,
                    sortable: true,
                    width: 105,
                    filterable: true,
                    formatter: CashFormatter,
                },
                {
                    key: 'MemoNum',
                    name: <Translate value="memo_poundsign" />,
                    resizable: true,
                    sortable: true,
                    width: 150,
                    filterable: true,
                },
                {
                    key: 'CreateTime',
                    name: <Translate value="created" />,
                    resizable: true,
                    sortable: true,
                    width: 90,
                    filterable: true,
                    formatter: DateFormatter
                }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '100%' }} id="PurchaseReturnList-dataGrid1">
                    <ReactDataGrid
                        rowKey='PurchaseReturn_id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        rowHeight={25}
                        minHeight={tableHeight}
                        enableRowSelect='single'
                        onRowUpdated={this.handleRowUpdated}
                        onRowSelect={onRowSelect} />
                </div></Col></Row>
            )
        }
    }

    renderPrintIframe() {
      const { returnPDFFrameLoaded } = this.state;
      const { purchaseReturnPdf } = this.props;
      return (
        <PrintIframe
          id="returnPDF"
          loaded={returnPDFFrameLoaded}
          name="returnPDF"
          onLoad={this.handlePrintFrameOnLoad}
          pdf={purchaseReturnPdf}
          title={<Translate value="print_purchase_return" />}
        />
      );
    }

    renderPrintNsIFrame() {
      const { returnPdfFrameLoadedNs } = this.state;
      const { purchaseReturnPdfNs } = this.props;
      return (
        <PrintIframe
          id="returnNsPdf"
          loaded={returnPdfFrameLoadedNs}
          name="returnNsPDF"
          onLoad={this.handlePrintFrameNsOnLoad}
          pdf={purchaseReturnPdfNs}
          title={<Translate value="print_purchase_return_no_$" />}
        />
      );
    }

    checkPermission(permission) {
        return false;
    }

    setToDate = (e) => {
      if (e < this.state.fromDate) {
        return;
      }
      this.setState({ toDate: e });
    }

    setFromDate = (e) => {
      if (e > this.state.toDate) {
        return;
      }
      this.setState({ fromDate: e });
    }

    setToRangeSearch = (e) => {
      this.setState({ days: '-1' });
    }

    handleStatusFilterChange = (status) => {
      const route = this.context.router.routes[1].path;
      const { days, fromDate, toDate } = this.state;
      this.setState(
        { status: status },
        () => { this.props.fetchPurchaseReturns(fromDate, toDate, days, status); },
      );
    }

    handleDaysFilterChange = (days) => {
      const route = this.context.router.routes[1].path;
      const { fromDate, toDate, status } = this.state;
      this.setState(
        { days: days },
        () => { this.props.fetchPurchaseReturns(fromDate, toDate, days, status); },
      );
    }

    getExcelUrl() {
      let fromDate = '1900-01-01';
      let toDate = '3000-01-01';
      let returnStatusString = `ReturnStatus=${this.state.status}`;
      if (this.state.fromDate) {
        fromDate = dateFormat('YYYY-MM-DD', this.state.fromDate);
      }
      if (this.state.toDate) {
        toDate = dateFormat('YYYY-MM-DD', this.state.toDate);
      }
      const dates = toFromDates(this.state.days, fromDate, toDate);
      // if "all" status is selected, dont pass a ReturnStatus
      if (this.state.status === 'all') {
        returnStatusString = '';
      }
      return `${ROOT_URL}v1/purchase/return/excel/?PostingDate__gte=${dates.fromDate}&PostingDate__lte=${dates.toDate}&${returnStatusString}&Bearer=${localStorage.getItem('token')}`;
    }

    render() {
      const createDialogStyle = {
        width: '550px',
        height: '300px',
        marginLeft: '-15%',
      };
        let height = (this.state.tableHeight + 140).toString();
        let tableCollapseFix = { height: height}
        const purchaseReturnID = (this.state.selectedRows) && this.state.selectedRows[0].PurchaseReturn_id;
        const voidButtonShouldDisable = !this.state.selectedRows || this.state.selectedRows.length !== 1 ||
          this.props.purchaseReturnIsVoiding || this.state.selectedRows[0].ReturnStatus !== 'Open';
        // const printUrl = `${ROOT_URL}v1/purchase/return/print/${PurchaseReturn_id}/?Bearer=${localStorage.getItem('token')}`;
        return (
          //---------------
          // Begin HTML
          //---------------
          <ContentWrapper>
            <Breadcrumb>
              <Breadcrumb.Item>
                <Translate value="purchase_management" />
              </Breadcrumb.Item>
              <Breadcrumb.Item active="true">
                <Translate value="purchase_return" />
              </Breadcrumb.Item>
            </Breadcrumb>

            <Grid id="purchase-return-list">

              <Row>
                <Col xs={12}>
                  <Panel id="date-range-picker" className="form-horizontal">
                    <Row>
                      <Col xs={2}>
                        <h3 className="filter-title"><Translate value="return_status" /><span className="colon">:</span></h3>
                      </Col>
                      <Col xs={10}>
                        <div id="statusFilterRadios" className="form-horizontal">
                          {
                            genericRadioFilter({
                              content: [
                                {
                                    option: 'all',
                                    id: 'all-radio-filter',
                                    name: 'statusFilterRadios',
                                    labelName: 'all',
                                },
                                {
                                    option: 'Open',
                                    id: 'open-radio-filter',
                                    name: 'statusFilterRadios',
                                    labelName: 'open',
                                },
                                {
                                    option: 'Void',
                                    id: 'void-radio-filter',
                                    name: 'statusFilterRadios',
                                    labelName: 'void',
                                },
                                {
                                    option: 'Completed',
                                    id: 'completed-radio-filter',
                                    name: 'statusFilterRadios',
                                    labelName: 'completed',
                                },
                              ],
                              value: this.state.status,
                              handleOnClick: this.handleStatusFilterChange,
                              type: 'buttons',
                            })
                          }
                        </div>
                      </Col>
                      <Col xs={2}>
                        <h3 className="filter-title"><Translate value="return_date" /><span className="colon">:</span></h3>
                      </Col>
                      <Col xs={10}>
                        {
                          dateFilterRadios({
                            handleOnClick: this.handleDaysFilterChange,
                            setFromDate: this.setFromDate,
                            setToDate: this.setToDate,
                            setToRangeSearch:this.setToRangeSearch,
                            fromDate: this.state.fromDate,
                            toDate: this.state.toDate,
                            Days: this.state.days,
                          })
                        }
                      </Col>
                    </Row>
                  </Panel>
                </Col>
              </Row> {/* End Date Range Picker */}

              <Row>
                <Col xs={12}>
                  <Panel className="position-relative table-collapse-fix">
                    <ButtonToolbar className="table-buttons">
                      <Button
                        bsStyle="success"
                        type="submit"
                        onClick={(event) => { this.createPurchaseReturn(event); }}
                        disabled={!checkPermission('add_purchase_return')}
                      >
                        <em className="fa fa-plus" /><Translate value="create_purchase_return" />
                      </Button>
                      <Button
                        bsStyle="success"
                        type="submit"
                        onClick={(event) => { this.createPurchaseCredit(event); }}
                        disabled={!checkPermission('add_purchase_return')}
                      >
                        <em className="fa fa-plus" /><Translate value="receive_credit" />
                      </Button>
                      <Button
                        bsStyle="warning"
                        type="button"
                        onClick={(event) => { this.setCurrentPurchaseReturn(event); }}
                        disabled={(!this.state.selectedRows || this.state.selectedRows.length !== 1) || !checkPermission('change_purchase_return')}
                      >
                        <em className="fa fa-pencil" /><Translate value="edit" />
                      </Button>
                      <SpinnerButton
                        bsStyle="danger"
                        disabled={voidButtonShouldDisable || !checkPermission('delete_purchase_return')}
                        icon="fa-trash"
                        translation={<Translate value="void" />}
                        loading={this.props.purchaseReturnIsVoiding}
                        onClick={() => { this.openCheckAuthorize('void'); }}
                      />
                      <SpinnerButton
                        bsStyle="primary"
                        disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1 || this.props.requestingPurchaseReturnPdf || !checkPermission('print_purchase_return')}
                        icon="fa-print"
                        translation={<Translate value="print" />}
                        loading={this.props.requestingPurchaseReturnPdf}
                        onClick={() => {
                          this.props.printPurchaseReturn(purchaseReturnID);                        
                        }}
                      />
                      <SpinnerButton
                        bsStyle="primary"
                        disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1 || this.props.requestingPurchaseReturnPdf || !checkPermission('print_purchase_return')}
                        icon="fa-print"
                        translation={<Translate value="print_no_$" />}
                        loading={this.props.requestingPurchaseReturnPdf}
                        onClick={() => {
                          this.props.printPurchaseReturnNoSubtotals(purchaseReturnID);

                        }}
                      />
                      <Button
                        bsStyle="success"
                        href={this.getExcelUrl()}
                        disabled={!this.state.rows.length || !checkPermission('print_purchase_return')}
                      >
                        <em className="fa fa-download" /><Translate value="excel" />
                      </Button>
                    </ButtonToolbar>
                    {this.renderTable()}
                  </Panel>
                </Col>
              </Row>
            </Grid>
            {this.renderPrintIframe()}
            {this.renderPrintNsIFrame()}
            <SkyLightStateless
              dialogStyles={createDialogStyle}
              isVisible={this.state.checkAuthorizeOpen}
              onCloseClicked={this.closeCheckAuthorize}
            >
              <ConfirmActionModal
                case="confirmPassword"
                closeC={this.checkAuthorize}
                checkPasswordFailure={this.props.checkPasswordFailure}
              />
            </SkyLightStateless>
          </ContentWrapper>
          //---------------
          // End HTML
          //---------------
        );
    }
}

// <Row>
//                     <Button
//                         bsStyle="primary"
//                         style={{ marginLeft: '20px' }}
//                         onClick={this.openCreate}>
//                         <em className="fa fa-plus" style={{marginRight: "10px"}}/>Add Purchase Return
//                     </Button>
//                     <Button
//                         bsStyle="primary"
//                         style={{ marginLeft: '20px' }}
//                         onClick={(event) => { this.setCurrentPurchaseReturn(event) } }
//                         disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}>
//                         <em className="fa fa-pencil" style={{marginRight: "10px"}}/>Edit Purchase Return
//                     </Button>
//                 </Row>
//                 <br/>
//                 {this.renderTable() }


export default PurchaseReturnList;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchaseReturnList.jsx